import { Injectable, signal } from "@angular/core"

@Injectable({
  providedIn: "root",
})
export class RedlineMapService {
  private _visited = signal(false)
  visited = this._visited.asReadonly()

  setVisited(value: boolean) {
    this._visited.set(value)
  }

}
